var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShipped(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0974 6.10449L7.9834 8.32837L3.86943 6.10449C3.49543 5.8821 3.04664 6.03036 2.82224 6.40101C2.67264 6.77165 2.74744 7.21643 3.12144 7.43882L7.23541 9.66269V14.2587C7.23541 14.7035 7.53461 15 7.9834 15C8.4322 15 8.7314 14.7035 8.7314 14.2587V9.66269L12.8454 7.43882C13.2194 7.21643 13.369 6.77165 13.1446 6.40101C12.9202 6.03036 12.4714 5.8821 12.0974 6.10449Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.925 3.76532L9.425 1.1433C8.525 0.618899 7.4 0.618899 6.5 1.1433L2.075 3.76532C1.1 4.28973 0.5 5.41345 0.5 6.53717V11.4816C0.5 12.6053 1.1 13.729 2.075 14.2534L6.575 16.8754C7.025 17.1002 7.475 17.25 8 17.25C8.525 17.25 8.975 17.1002 9.425 16.8754L13.925 14.2534C14.9 13.729 15.5 12.6053 15.5 11.4816V6.53717C15.5 5.41345 14.9 4.28973 13.925 3.76532ZM14 11.4816C14 12.0809 13.7 12.6802 13.175 12.9799L8.675 15.6019C8.225 15.8266 7.7 15.8266 7.25 15.6019L2.75 12.9799C2.225 12.6802 1.925 12.1558 1.925 11.4816V6.53717C1.925 5.93785 2.225 5.33854 2.75 5.03888L7.25 2.41686C7.55 2.34194 7.775 2.26703 8 2.26703C8.225 2.26703 8.45 2.34194 8.675 2.49177L13.175 5.11379C13.7 5.41345 14 5.93785 14 6.61209V11.4816Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipped);
export default __webpack_public_path__ + "static/media/shipped.e7329ebe426418a0f9f39063ad9dcc10.svg";
export { ForwardRef as ReactComponent };